"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import dynamic from "next/dynamic";
import { DEACTIVATE_DP_ENUM } from "@/lib/constants/dp-enum";
import useDeviceType from "@/lib/constants/useDeviceType";
import { inhomzEvents } from "@/app/(fevicol-inhomz)/_lib/events";
import { profileEventProps } from "@/app/(fevicol-inhomz)/_lib/profileEventProps";
import { useInhomzTrack } from "@/app/(fevicol-inhomz)/_hooks/useInhomzTrack";
const ProfilePhotoZoomOverlay = dynamic(() => import("./ProfilePhotoZoomOverlay"), {
  ssr: false
});
const ProfilePhotoCarouselOverlay = dynamic(() => import("./ProfilePhotoCarouselOverlay"), {
  ssr: false
});

/**
 * Wraps the profile photo thumbnail. On tap/click opens a full-screen overlay:
 * - Logo + profile: swipeable carousel (logo first with profile peeking on the right)
 * - Profile only (mobile): zoomed profile photo with DpCTA
 */
export default function ProfilePhotoWithZoom(t0) {
  const $ = _c(32);
  const {
    logo,
    profilePicture,
    digitalProfile,
    status,
    children,
    isLeadGenProfile,
    hideGetInTouch
  } = t0;
  const [overlayOpen, setOverlayOpen] = useState(false);
  const track = useInhomzTrack();
  const isDesktop = useDeviceType();
  const isMobile = !isDesktop;
  const isActive = digitalProfile && status !== DEACTIVATE_DP_ENUM;
  const hasCarousel = Boolean(logo) && Boolean(profilePicture) && isActive;
  const canOpen = isActive && (hasCarousel || isMobile);
  let t1;
  if ($[0] !== canOpen || $[1] !== digitalProfile || $[2] !== hasCarousel || $[3] !== track) {
    t1 = () => {
      if (!canOpen) {
        return;
      }
      track(inhomzEvents.contractorProfile.PROFILE_IMG_CLICKED, {
        ...profileEventProps(digitalProfile),
        event_value: hasCarousel ? "logo_and_profile" : "profile"
      });
      setOverlayOpen(true);
    };
    $[0] = canOpen;
    $[1] = digitalProfile;
    $[2] = hasCarousel;
    $[3] = track;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handlePhotoClick = t1;
  const t2 = canOpen ? handlePhotoClick : undefined;
  const t3 = canOpen ? "button" : undefined;
  const t4 = canOpen ? hasCarousel ? "View business logo and profile photo" : "View profile photo" : undefined;
  const t5 = canOpen ? "cursor-pointer" : "";
  let t6;
  if ($[5] !== children || $[6] !== t2 || $[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
    t6 = <div onClick={t2} role={t3} aria-label={t4} className={t5}>{children}</div>;
    $[5] = children;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== digitalProfile || $[12] !== hasCarousel || $[13] !== hideGetInTouch || $[14] !== isLeadGenProfile || $[15] !== logo || $[16] !== overlayOpen || $[17] !== profilePicture || $[18] !== status) {
    t7 = overlayOpen && hasCarousel && <ProfilePhotoCarouselOverlay open={overlayOpen} onClose={() => setOverlayOpen(false)} logo={logo} profilePicture={profilePicture} digitalProfile={digitalProfile} status={status} isLeadGenProfile={isLeadGenProfile} hideGetInTouch={hideGetInTouch} />;
    $[11] = digitalProfile;
    $[12] = hasCarousel;
    $[13] = hideGetInTouch;
    $[14] = isLeadGenProfile;
    $[15] = logo;
    $[16] = overlayOpen;
    $[17] = profilePicture;
    $[18] = status;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== digitalProfile || $[21] !== hasCarousel || $[22] !== hideGetInTouch || $[23] !== isLeadGenProfile || $[24] !== overlayOpen || $[25] !== profilePicture || $[26] !== status) {
    t8 = overlayOpen && !hasCarousel && <ProfilePhotoZoomOverlay open={overlayOpen} onClose={() => setOverlayOpen(false)} profilePicture={profilePicture} digitalProfile={digitalProfile} status={status} isLeadGenProfile={isLeadGenProfile} hideGetInTouch={hideGetInTouch} />;
    $[20] = digitalProfile;
    $[21] = hasCarousel;
    $[22] = hideGetInTouch;
    $[23] = isLeadGenProfile;
    $[24] = overlayOpen;
    $[25] = profilePicture;
    $[26] = status;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t6 || $[29] !== t7 || $[30] !== t8) {
    t9 = <>{t6}{t7}{t8}</>;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  return t9;
}